module.exports = __webpack_public_path__ + "src/assets/images/logo-benji@2x.png?5bac5cb80171fb2fe3a7e748a36bb1f8";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-benji@2x.png
// module id = 1016
// module chunks = 1